import { render, staticRenderFns } from "./VehiculesModal.vue?vue&type=template&id=f48b5a42&"
import script from "./VehiculesModal.vue?vue&type=script&lang=js&"
export * from "./VehiculesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports